import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LessonCardForVertical } from '@lean-body/components/molecules';
import { VerticalListArrows } from '@lean-body/components/molecules/vertical_list_arrows';
import { separateArrayBySpecifiedNumber } from '@lean-body/src/util';
import { LIST_ITEM_MARGIN_RIGHT } from '../pages/main_home';
const VERTICAL_COUNT = 3;
export const LessonComponentCarouselSeparate = ({ lessons, classObject, verticalListArrowsClassObject, itemsPadding, addFavoriteLesson, unFavoriteLesson, itemSize, isBig, }) => {
    return (React.createElement(VerticalListArrows, { itemMarginRight: LIST_ITEM_MARGIN_RIGHT, classObject: [verticalListArrowsClassObject, classObject, styles.container], itemsPadding: itemsPadding, itemSize: itemSize, items: separateArrayBySpecifiedNumber(lessons, VERTICAL_COUNT).map((lessons) => (React.createElement("div", { className: css(styles.itemContainer) }, lessons.map((lesson, i) => {
            return (React.createElement(LessonCardForVertical, { lesson: lesson, classObject: [styles.container, classObject], addFavoriteLesson: addFavoriteLesson, unFavoriteLesson: unFavoriteLesson, isBig: isBig, key: i }));
        })))) }));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
    },
    itemContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'scroll',
        '::-webkit-scrollbar': {
            display: 'none',
        },
    },
});
